import React from "react";
import { formatINR, calcDiscountPct } from "../../lib/utils-cynos";

const PriceDisplay = ({ price, originalPrice, size = "md" }) => {
  const pct = calcDiscountPct(price, originalPrice);
  const priceClass = size === "lg" ? "text-4xl" : "text-xl";
  return (
    <div className="flex flex-wrap items-baseline gap-3">
      <span className={`font-anton ${priceClass}`}>{formatINR(price)}</span>
      {originalPrice > price && (
        <>
          <span className="text-zinc-500 line-through text-lg">{formatINR(originalPrice)}</span>
          {pct > 0 && (
            <span className="rounded-[6px] bg-cynos-red px-2 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-white">
              -{pct}% Off
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default PriceDisplay;
